import { Injectable } from "@angular/core";
import { Apollo } from "apollo-angular";
import { Observable } from "rxjs";

import { map } from "rxjs/operators";
import {
  FetchResult,
  MutationOptions,
  OperationVariables,
  PureQueryOptions,
} from "@apollo/client";

@Injectable({
  providedIn: "root",
})
export class ApolloGraphQlService {
  constructor(private apollo: Apollo) {}

  executeQuery<TReturn>(queryOptions: PureQueryOptions): Observable<TReturn> {
    return this.apollo
      .watchQuery<TReturn>(queryOptions)
      .valueChanges.pipe(map((result) => result.data));
  }

  // tslint:disable-next-line: max-line-length
  executeQueryWithMappedFunction<TReturn, TGraphQlReturn>(
    queryOptions: PureQueryOptions,
    mapFunction: (a: TGraphQlReturn) => TReturn
  ): Observable<TReturn> {
    return this.apollo
      .watchQuery<TGraphQlReturn>(queryOptions)
      .valueChanges.pipe(map((result) => mapFunction(result.data)));
  }

  executeQueryWithMappedFunctionAndReferenceThis<TReturn, TGraphQlReturn>(
    queryOptions: PureQueryOptions,
    mapFunction: (a: TGraphQlReturn, b: any) => TReturn,
    referenceService: any
  ): Observable<TReturn> {
    return this.apollo
      .watchQuery<TGraphQlReturn>(queryOptions)
      .valueChanges.pipe(
        map((result) => mapFunction(result.data, referenceService))
      );
  }

  executeQueryWithMappedFunctionAndOtherData<TReturn, TGraphQlReturn>(
    queryOptions: PureQueryOptions,
    mapFunction: (a: TGraphQlReturn, b: any) => TReturn,
    otherData: any
  ): Observable<TReturn> {
    return this.apollo
      .watchQuery<TGraphQlReturn>(queryOptions)
      .valueChanges.pipe(
        map((result) => {
          return mapFunction(result.data, otherData);
        })
      );
  }

  executeMutation<T = { [key: string]: any }, TVariables = OperationVariables>(
    mutationOptions: MutationOptions<T, TVariables>
  ): Observable<FetchResult<T>> {
    let temp = this.apollo.mutate<T, TVariables>(mutationOptions).pipe(
      map((result) => {
        return result.data;
      })
    );

    return temp;
  }
}
